export default class SpecialEventPopup {
    constructor() {
        this.$root = document.getElementById('specialEventPopup');
        this.$closeButton = document.getElementById('specialEventPopupCloseButton');
        this.$quizTrigger = document.getElementById('modalSpecialEventQuizTrigger');

        this.cookie = costorage.get('h_specialEventPopup');

        this.init();
    }

    init() {
        if (this.cookie || location.hash.includes('special-event')) return;

        setTimeout(() => {
            this.$root.classList.add('-active');
        }, 3000);

        this.$closeButton.addEventListener('click', () => {
            this.$root.classList.remove('-active');
            costorage.set('h_specialEventPopup', 1, { expires: (24 * 60 * 60), path: '/', domain: craft.env.isInternational ? '.ithillel.com' : '.ithillel.ua' });
        });

        this.$quizTrigger.addEventListener('click', () => {
            this.$root.classList.remove('-active');
        });
    }
}